export const extractPlaylistId = (youtubeUrl: string): string | null => {
    const regex = /[?&]list=([^&]+)/;
    const match = youtubeUrl.match(regex);
    return match ? match[1] : null;
  };
  
  export const getEmbeddedYouTubeURL = (
    youtubeUrl: string,
  ): string | undefined => {
    if (!youtubeUrl) return;
  
    try {
      const url = new URL(youtubeUrl);
  
      // 🎯 플레이리스트일 경우
      const listId = url.searchParams.get('list');
      if (listId) {
        return `https://www.youtube.com/embed/videoseries?list=${listId}`;
      }
  
      // 🎯 단일 영상일 경우
      const videoIdMatch = youtubeUrl.match(
        /(?:youtube\.com\/.*v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/,
      );
      const videoId = videoIdMatch?.[1];
  
      if (videoId) {
        return `https://www.youtube.com/embed/${videoId}`;
      }
    } catch (e) {
      // Invalid URL → 아무것도 반환하지 않음
    }
  };
  